// extracted by mini-css-extract-plugin
module.exports = {"loadingBlock":"loadingBlock___2h6mG","centered":"centered___22peW"};